import ClockIcon from "@svg/new-design/clock";
import IconGraduation from "@svg/product/Graduation";
import JobIcon from "@svg/product/Job";
import { useAccess } from "@templates/course/hooks/useAccess";
import { COURSE_TYPE } from "@types";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { FC } from "react";

const ProductPageSidebarPublishedFooter: FC<{ dense?: boolean }> = ({
  dense,
}) => {
  const { courseData } = useAccess();
  const {
    product: { jobCount, duration, examCount, attribute_type },
  } = courseData;

  const farsiDuration =
    duration.in_minutes >= 120 ? duration.rounded_in_hour : duration.in_minutes;
  const durationTitle =
    attribute_type === COURSE_TYPE.COURSE ? "آموزش ویدئویی" : "پادکست صوتی";
  const durationLabel = duration.in_minutes >= 120 ? "ساعت" : "دقیقه";

  return (
    <div className="flex flex-col gap-1">
      {Boolean(farsiDuration) && (
        <div className="flex gap-1.5  items-center w-full justify-start">
          <ClockIcon className="text-fds-icon-tertiary w-4     md:w-5  h-4 md:h-5" />
          <p className="title-sm text-fds-secondary">
            {toFarsiNumber(farsiDuration)} {durationLabel} {durationTitle}
          </p>
        </div>
      )}
      {Boolean(examCount) && (
        <div className="flex gap-1.5  items-center w-full justify-start">
          <IconGraduation className="text-fds-icon-tertiary w-4     md:w-5    h-4     md:h-5" />
          <p className="title-sm text-fds-secondary">
            {separateMoneyNumbers(toFarsiNumber(examCount))} سوال سنجش یادگیری
          </p>
        </div>
      )}
      {Boolean(jobCount) && (
        <div className="flex gap-1.5  items-start w-full justify-start">
          <JobIcon className="text-fds-icon-tertiary w-4  md:w-5  h-4  md:h-5" />
          <p className="title-sm  text-fds-secondary">
            {separateMoneyNumbers(toFarsiNumber(jobCount))} فرصت شغلی مرتبط{" "}
            <span className="text-fds-secondary md:body-xsm body-sm">
              (در سایت‌های مطرح کاریابی)
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductPageSidebarPublishedFooter;
